module.exports = __webpack_public_path__ + "img/18.63bc9644.svg";